export default "__VITE_ASSET__CEV1pb8k__"